module.exports = __webpack_public_path__ + "img/ScreenshotsofYOWhatsApp.e3e2ca43.webp";